import { CardHeader, CardTitle } from "@/components/ui/card"
import { cn } from "@/lib/utils"

export default function ModalTitle({
  children,
  className,
}: {
  children: React.ReactNode
  className?: string
}) {
  return (
    <CardHeader className="pb-0 w-full">
      <CardTitle
        className={cn(
          "text-lg text-foreground text-center font-semibold",
          className
        )}
      >
        {children}
      </CardTitle>
    </CardHeader>
  )
}
